import { AppState } from "../../../store/interfaces";

const selectCartItems = (state: AppState) => state.cart.items;
const selectCartItemsCount = (state: AppState) => state.cart.items.length;
const selectPayPalPaymentStatus = (state: AppState) => state.cart.payPalPaymentInProcess;

export { selectCartItems, selectCartItemsCount, selectPayPalPaymentStatus };
